module.exports = __webpack_public_path__ + "static/noah-4ea977f28aeef7e9f67d8fc7dd00a17b.webp";